import { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { MODAL_TITLE_TYPE } from '@/lib/typography';
import { JOURNAL_PHRASE_MODAL_Z_CLASS } from '@/lib/journal/journalOverlayLayers';
import { AccessibleOverlay } from './AccessibleOverlay';
import { JournalPhrasesManager } from './JournalPhrasesManager';

interface ManageJournalPhrasesModalProps {
  clinicId: string;
  open: boolean;
  onClose: () => void;
}

export function ManageJournalPhrasesModal({
  clinicId,
  open,
  onClose,
}: ManageJournalPhrasesModalProps) {
  const { t } = useTranslation();
  const titleId = useId();

  return (
    <AccessibleOverlay
      open={open}
      onClose={onClose}
      labelledBy={titleId}
      zClassName={JOURNAL_PHRASE_MODAL_Z_CLASS}
      panelClassName="mx-auto mt-10 max-w-lg rounded-xl bg-ds-card shadow-pop"
    >
      <div className="flex items-center justify-between border-b border-ds-line px-4 py-3">
        <h3 id={titleId} className={MODAL_TITLE_TYPE}>
          {t('journal.phrases.manage')}
        </h3>
        <Button
          type="button"
          variant="tertiary"
          size="icon"
          onClick={onClose}
          aria-label={t('common.close')}
        >
          <X />
        </Button>
      </div>
      <div className="max-h-[70vh] overflow-y-auto p-4">
        <JournalPhrasesManager clinicId={clinicId} scope="clinician" />
      </div>
    </AccessibleOverlay>
  );
}
